import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Navigation, UserMenu } from '.';
import { NavLink } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';

export function Header() {
  const { Header } = Layout;

  const [isTestEnv, setIsTestEnv] = useState(false);

  useEffect(() => {
    setIsTestEnv(window.location.hostname.includes('-test'));
  }, []);

  return (
    <SizeMe>
      {({ size }) => (
        <Header style={{ display: 'flex', justifyContent: 'space-between', zIndex: 10, backgroundColor: '#294D78' }}>
          <div>
            <NavLink to="/">
              <h1 style={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
                {/* <img src="/logo-white.png" alt="LeanApp" height={30} style={{ marginRight: '1rem' }} /> */}
                <span>LeanApp - İSG Portalı</span>
                {isTestEnv && <span style={{ marginLeft: '1rem', color: '#ff0000' }}>TEST</span>}
              </h1>
            </NavLink>
          </div>
          <div style={{ flexGrow: 1 }}>
            <Navigation />
          </div>
          <div style={{ marginLeft: '2rem' }}>
            <UserMenu headerSize={size} />
          </div>
        </Header>
      )}
    </SizeMe>
  );
}
